"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var Alert_1 = tslib_1.__importDefault(require("./Alert"));
/**
 * @deprecated Use Alert from Antd
 * https://ant.design/components/alert/
 */
exports.default = Alert_1.default;
